export default __webpack_public_path__ + "static/media/pin_Innovation Leaders_colour.e18f00b7.png";